module.exports = __webpack_public_path__ + "img/vip_municipal.b1a09ad7.png";